export const REDIRECT_FROM_MODULE = {
    STOW: "STOW",
    INDUCT: "INDUCT"
}

export const CONSENT_STATUS = {
    NOT_FOUND: "NOT_FOUND",
    CONSENTED: "CONSENTED",
    DECLINED: "DECLINED"
}

export const USER_RESPONSE = {
    ASK_ME_LATER: "ASK_ME_LATER",
    CONSENTED: "CONSENTED",
    DECLINED: "DECLINED"
}

export const MY_INSIGHTS_FEATURES = {
    STOW_PROCESS: "stow_process_widget",
    STOW_SUMMARY: "stow_summary_view"
};

export const EXPERIMENT_STATUS = {
    CONTROL: "CONTROL",
    TREATMENT: "TREATMENT"    
}
